import { normalizeSportsbookId } from "@/lib/sportsbook-registry";
import type { PlatformType } from "./utils-v2";
import { OPTIMIZER_BOOKS } from "./optimizer-books";
import { FANTASY_PROPS_BOOKS } from "./props-books";
import { OPTIMIZER_ANALYTICAL_BOOKS } from "./sportsbook-field-groups";
import { ALL_SPORTSBOOK_COLUMNS } from "./desktop-optimizer-table.columns";
import { WHALES_COLUMN, type ComparisonColumnId } from "@/lib/whales";

const COLUMN_BACKED_COMPARISON_BOOKS: readonly PlatformType[] =
  ALL_SPORTSBOOK_COLUMNS.flatMap((column) =>
    column.platform ? [column.platform] : [],
  );

export const OPTIMIZER_COMPARISON_ORDER: readonly PlatformType[] = (() => {
  const seen = new Set<PlatformType>();
  const result: PlatformType[] = [];
  for (const book of [
    ...OPTIMIZER_BOOKS,
    ...FANTASY_PROPS_BOOKS,
    ...OPTIMIZER_ANALYTICAL_BOOKS,
    ...COLUMN_BACKED_COMPARISON_BOOKS,
  ]) {
    if (!seen.has(book)) {
      seen.add(book);
      result.push(book);
    }
  }
  return result;
})();

const OPTIMIZER_COMPARISON_BOOK_SET = new Set<PlatformType>(
  OPTIMIZER_COMPARISON_ORDER,
);

export const COMPARISON_COLUMN_ORDER: readonly ComparisonColumnId[] = [WHALES_COLUMN, ...OPTIMIZER_COMPARISON_ORDER];

export function isComparisonBook(id: ComparisonColumnId): id is PlatformType {
  return id !== WHALES_COLUMN;
}

export function resolveComparisonColumns(saved?: readonly string[] | null): ComparisonColumnId[] {
  const result: ComparisonColumnId[] = [];
  const seen = new Set<ComparisonColumnId>();
  for (const raw of saved ?? []) {
    const id = raw === WHALES_COLUMN ? WHALES_COLUMN : normalizeSportsbookId(raw);
    if (!id || seen.has(id) || (isComparisonBook(id) && !OPTIMIZER_COMPARISON_BOOK_SET.has(id))) continue;
    seen.add(id);
    result.push(id);
  }
  if (!seen.has(WHALES_COLUMN)) result.unshift(WHALES_COLUMN);
  for (const book of OPTIMIZER_COMPARISON_ORDER) if (!seen.has(book)) result.push(book);
  return result;
}

export function getComparisonBookRankMap(
  order: readonly PlatformType[] = OPTIMIZER_COMPARISON_ORDER,
): Record<string, number> {
  const map: Record<string, number> = {};
  order.forEach((book, i) => {
    map[book] = i + 1;
  });
  return map;
}
